import { render } from "./ButtonSquare.vue?vue&type=template&id=00c6ac12&scoped=true"
import script from "./ButtonSquare.vue?vue&type=script&lang=js"
export * from "./ButtonSquare.vue?vue&type=script&lang=js"

import "./ButtonSquare.vue?vue&type=style&index=0&id=00c6ac12&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c6ac12"]])

export default __exports__